import { useEffect, useState } from "react";

//import material
import {
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Card,
  Paper,
  CardHeader,
  Typography,
  CardContent,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Divider,
  Stack,
  Box,
  useTheme,
  CircularProgress,
  Snackbar,
  Alert,
  Tooltip,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import LaunchIcon from "@mui/icons-material/Launch";
//import config from "../../../../config";

//project components

import useAxiosAuth from "../../../../hooks/useAxiosAuth";
import { convertDateToLocal } from "../../../../utils/date-operations";
import NoDataFound from "../../../../components/NoDataFound";
import { useNavigate } from "react-router-dom";

const TomorrowsCandidateFollowup = (props) => {
  //Constants
  const axiosAuth = useAxiosAuth();
  const pageSize = 100;
  const theme = useTheme();
  const navigate = useNavigate();
  //States
  const [tomorrowsFollowup, setTomorrowsFollowup] = useState([]);
  const [loading, setLoading] = useState(true);

  //Methods
  const handleGetTomorrowsFollowups = (skip) => {
    setLoading(true);
    axiosAuth
      .get("/api/Dashboards/tomorrows-candidate-followups")
      .then((response) => {
        setTomorrowsFollowup(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetTomorrowsFollowups();
  }, []);

  return (
    <>
      <Grid
        container
        maxWidth="xl"
        sx={{ marginX: "auto", paddingY: 2, paddingX: 2 }}
      >
        <Card elevation={3} sx={{ width: "100%" }}>
          <Grid
            container
            sx={{
              background: "linear-gradient(to right,#4a7dcf 0%, #2a569f 100%)",
              paddingX: 2,
              paddingY: 1,
            }}
          >
            <Typography variant="h5" color="white.main">
              Tomorrows Candidate Followup
            </Typography>
          </Grid>
          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 200,
              }}
            >
              <Stack
                direction="column"
                spacing={2}
                justifyContent="center"
                alignItems="center"
              >
                <Typography variant="body1">Loading List...</Typography>
                <CircularProgress />
              </Stack>
            </Box>
          ) : Array.isArray(tomorrowsFollowup?.data) &&
            tomorrowsFollowup?.data?.length === 0 ? (
            <Grid item xs={12}>
              <NoDataFound />
            </Grid>
          ) : (
            <TableContainer sx={{ padding: 2 }}>
              <Table
                size="small"
                sx={{
                  borderWidth: 1,
                  border: "solid",
                  borderColor: "#f2f2f2",
                }}
              >
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#e6eeff" }}>
                    <TableCell sx={{ width: 50 }}>#</TableCell>
                    <TableCell align="left">Name </TableCell>
                    <TableCell align="left" sx={{ width: 160 }}>
                      Mobile Number
                    </TableCell>
                    <TableCell align="left" sx={{ width: 180 }}>
                      Next Followup Date
                    </TableCell>
                    <TableCell align="right" sx={{ width: 80 }}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tomorrowsFollowup.data?.map((row, index) => (
                    <TableRow key={row.id}>
                      <TableCell component="th" scope="row">
                        {index + 1}
                      </TableCell>
                      <TableCell align="left">
                        <Typography
                          variant="h6"
                          sx={{
                            color: "inherit",
                          }}
                        >
                          {row.name}
                        </Typography>
                      </TableCell>
                      <TableCell align="left">{row.mobileNumber}</TableCell>
                      <TableCell align="left">
                        {convertDateToLocal(row.date)}
                      </TableCell>
                      <TableCell align="right">
                        <Tooltip title="View Candidate Details">
                          <IconButton
                            variant="outlined"
                            color="primary"
                            size="small"
                            onClick={() => {
                              navigate("/profile?ref=" + row.candidateId);
                            }}
                          >
                            <LaunchIcon fontSize="inherit" />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Card>
      </Grid>
    </>
  );
};

export default TomorrowsCandidateFollowup;
